<template>
    <section class="inplay-section all-type-game" loading="lazy">
        <div class="remove-padding">
            <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-2">
                    <LeftSideMenu />
                </div>
                <div class="col-sm-12 col-md-9 col-lg-10">
                    <div class="box-detail matka-details-sec">
                        <section class="games-list-sec matka-list-sec">
                            <div class="matka-details-wrapper">
                                <div class="remove-padding">
                                    <div class="matka-games-list">
                                        <div class="back-btn-sec" v-if="!globalLoader">
                                            <a @click="$router.go(-1)">
                                                <span class="fa-solid fa-angle-left mr-icn"></span>
                                                <p>{{$t('matka','Matka')}}</p>
                                            </a>    
                                        </div>
                                        <div class="matka-header-tabs">
                                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link active" id="matka-market-tab" data-bs-toggle="tab" data-bs-target="#matka-market" type="button" role="tab" aria-controls="matka" aria-selected="true">{{$t('matka','Matka')}}</button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="all-market-tab" data-bs-toggle="tab" data-bs-target="#all-market" type="button" role="tab" aria-controls="all-market" aria-selected="false">{{$t('matka-result','Matka Result')}}</button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="tab-content" id="myTabContent">
                                            <div class="tab-pane fade show active" id="matka-market" role="tabpanel" aria-labelledby="matka-market-tab">
                                                <div class="mathka-con-wrapper">
                                                    <div v-if="matkasList != null && matkasList.length != 0">
                                                        <MatkaItem :matkasList="matkasList"></MatkaItem>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane fade" id="all-market" role="tabpanel" aria-labelledby="all-market-tab">   
                                                <div class="all-matka-wrapper">
                                                    <MatkaResults :worliList="matkasList"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <LanguageModal></LanguageModal>
    </section>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';

export default {
    name: "Matka",
    components:{
        NoDataFound: defineAsyncComponent(() =>
            import('@/shared/components/no-data/NoDataFound.vue')
        ),
        MatkaItem: defineAsyncComponent(() =>
            import('../components/MatkaItem.vue')
        ), 
        MatkaResults: defineAsyncComponent(() => 
           import('../components/MatkaResults.vue')
        ),
        LeftSideMenu: defineAsyncComponent(() => 
           import('../components/MatkaResults.vue')
        ),
        LanguageModal: defineAsyncComponent(() => 
           import('@/modules/wallet/components/LanguageModal.vue')
        ),
    },
    
    mounted() {
        this.getMatkasServiceCall();
        this.sectionGamesCasino = this.homeGames
        this.eventManage = this.$store?.getters?.eventManage;
    },
    data() {
        return {
            loading: false,
            selectedSportItem: null,
            matkasList: null,
            worliList: null,
            eventManage: null,
            intervalId: null
        }
    },
    computed: {
        ...mapGetters(['homeGames','globalLoader']),
        filteredMatkaList() {
            if (this.$auth.status && this.matkasList && this.eventManage) {
                let sportEventManage = this.eventManage.find(item => item.type == 'worli-matka');
                if (sportEventManage && sportEventManage.type_id != null) {
                    let idList = sportEventManage.type_id.split(',');
                    return this.matkasList.filter(item => !idList.includes(item.id.toString()));
                }
            }
            return this.matkasList;
        },
    },
    methods: {
        getMatkasServiceCall() {
            this.loading = true;
            this.$apiCall('get','GET_MATKAS', null, 'sports').then(response => {
                this.loading = false;
                this.marketList = [];
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            //this.$successToast(response.data.message);
                            this.matkasList = response?.data?.data.filter(item => item.is_active).sort((a,b) => {
                                return a.open_bids.localeCompare(b.open_bids);
                            });
                            this.updateCountdown();
                            this.intervalId = setInterval(this.updateCountdown, 1000);

                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        updateCountdown() {
            try {
                if (this.matkasList && this.matkasList.length !== 0) {
                    const now = new Date();

                    this.matkasList = this.matkasList.map((item) => {
                        let countdown = {
                            days: 0,
                            hours: 0,
                            minutes: 0,
                            seconds: 0,
                        };

                        // Parse openDate and open_bids
                        const openDateTime = new Date(item.openDate);
                        const [openHours, openMinutes] = item.open_bids.split(':');
                        openDateTime.setHours(parseInt(openHours));
                        openDateTime.setMinutes(parseInt(openMinutes));

                        // Parse closeDate and close_bids
                        const closeDateTime = new Date(item.closeDate);
                        const [closeHours, closeMinutes] = item.close_bids.split(':');
                        closeDateTime.setHours(parseInt(closeHours));
                        closeDateTime.setMinutes(parseInt(closeMinutes));

                        // Determine the appropriate countdown target
                        let targetTime;
                        if (now < openDateTime) {
                            // Countdown to open bids
                            targetTime = openDateTime;
                        } else if (now >= openDateTime && now <= closeDateTime) {
                            // Countdown to close bids
                            targetTime = closeDateTime;
                        }
                        if (targetTime) {
                            const difference = targetTime - now;
                            if (difference > 0) {
                                countdown.days = Math.floor(difference / (1000 * 60 * 60 * 24));
                                countdown.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                countdown.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                                countdown.seconds = Math.floor((difference % (1000 * 60)) / 1000);
                            }
                        }
                        return { ...item, countdown };
                    });
                }
            } catch (error) {
                console.log("Timer error: ", error);
            }
        },
        getCurrentTime() {
            const now = new Date();
            const hours = now.getHours().toString().padStart(2, "0");
            const minutes = now.getMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
        },
    }
}
</script>